import moment from "moment";

export const dateFormatter = (dateTime) => {
  return moment
    .parseZone(dateTime?.replace("+00:00", ""))
    .format("MMM DD, YYYY");
};

export const timeFormatter = (time) => {
  return moment(time?.replace("+00:00", "")).format("hh:mm A");
};
